var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { ExploreState } from '../../state/explore.state';
import { Observable, Subject } from 'rxjs';
import { Load, SortSearchResults, ResetSearchResults, CheckSearchResult, SetCheckedSearchResults, SelectCategory } from '../../state/explore.actions';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { takeUntil } from 'rxjs/operators';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { DialogActions } from 'src/app/dialogs/state/dialog.actions';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
var ExploreComponent = /** @class */ (function () {
    function ExploreComponent(route, store, changeDetectorRef, router) {
        this.route = route;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.router = router;
        this.galleryViewMode = GalleryViewMode;
        this.ngUnsubscribe = new Subject();
    }
    ExploreComponent.prototype.ngOnInit = function () {
        var _this = this;
        // load by category
        this.route.params
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) {
            var category = params.category;
            _this.loadByCategory(category);
        });
        this.searchResults$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (results) {
            _this.store.dispatch(new SetCheckedSearchResults([]));
            _this.changeDetectorRef.markForCheck();
        });
    };
    ExploreComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ResetSearchResults());
        this.store.dispatch(new SelectCategory(null));
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ExploreComponent.prototype.loadByCategory = function (category) {
        this.store.dispatch(new ResetSearchResults());
        this.store.dispatch(new SelectCategory(category));
        this.store.dispatch(new Load(category));
    };
    ExploreComponent.prototype.handleBookmarksSort = function (sort) {
        this.store.dispatch(new SortSearchResults(sort));
    };
    ExploreComponent.prototype.handleCheckChanged = function (checked, id) {
        this.setChecked(checked, id);
    };
    ExploreComponent.prototype.setChecked = function (checked, id) {
        this.store.dispatch(new CheckSearchResult(id, checked));
    };
    ExploreComponent.prototype.handleSelectAllClick = function () {
        this.selectAll();
    };
    ExploreComponent.prototype.handleClearSelectionClick = function () {
        this.store.dispatch(new SetCheckedSearchResults([]));
    };
    ExploreComponent.prototype.handleSelectBookmark = function (bookmark) {
        if (!bookmark.premium || this.store.selectSnapshot(AuthState.isPremiumUser)) {
            this.router.navigate(['/view'], { queryParams: { id: bookmark.id, type: StoryType.Module } });
        }
        else {
            this.store.dispatch(new DialogActions.OpenPremiumContent());
        }
    };
    ExploreComponent.prototype.selectAll = function () {
        var ids = this.store.selectSnapshot(ExploreState.getSearchResults)
            .map(function (bookmark) { return bookmark.id; });
        this.store.dispatch(new SetCheckedSearchResults(ids));
    };
    Object.defineProperty(ExploreComponent.prototype, "bookmarkActions", {
        get: function () {
            var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
            // [bookmarkActions.View, bookmarkActions.CopyLink, bookmarkActions.CopyBookmark, bookmarkActions.Edit, bookmarkActions.Share]
            return __spread([
                BookmarkActionsEnum.View,
                BookmarkActionsEnum.Edit,
                BookmarkActionsEnum.CopyLink,
                BookmarkActionsEnum.CopyBookmark
            ], organization ? [BookmarkActionsEnum.CopyTeamBookmark] : []);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Select(ExploreState.getSearchResults),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "searchResults$", void 0);
    __decorate([
        Select(ExploreState.getSort),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "sort$", void 0);
    __decorate([
        Select(ExploreState.getSelectedCategory),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "selectedCategory$", void 0);
    __decorate([
        Select(ExploreState.getLoading),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "loading$", void 0);
    __decorate([
        Select(GalleryState.getViewMode),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "viewMode$", void 0);
    __decorate([
        Select(AuthState.isPremiumUser),
        __metadata("design:type", Observable)
    ], ExploreComponent.prototype, "isPremiumUser$", void 0);
    return ExploreComponent;
}());
export { ExploreComponent };
